<template>
  <div>
    <Accordeon title="Wo finde ich weitere Informationen zum Verkehrsservice Hessen?">
      <template slot="answer">
        <ul>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCTYzC96BkkBa2vHf5cbxr3A"
              target="blank"
            >YouTube Videos</a>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://mobil.hessen.de/verkehr/verkehrsservice"
              target="blank"
            >Erläuterung auf der Website mobil.hessen.de</a>
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon
      title="Was sind die Unterschiede zu einem Navigationssystem oder bekannten Kartendiensten wie Google Maps?"
    >
      <template slot="answer">
        <ul>
          <li>
            Der Service ist kein Navigationssystem.
            Er bietet Ihnen den aktuellen Blick aus der Verkehrszentrale Hessen
            auf hessische Autobahnen und große Bundesstraßen.
            Er bündelt Echtzeitinformationen und dient Ihnen so als Informationsportal
            und Entscheidungsunterstützung.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Ich möchte einen Fehler melden oder habe einen Verbesserungsvorschlag.">
      <template slot="answer">
        <ul>
          <li>
            <a
              class="colorBlue"
              rel="noopener noreferrer"
              href="https://mobil.hessen.de/kontakt"
              target="_blank"
            >Schreiben Sie uns. Wir freuen uns über Ihre Hinweise.</a>
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Ihre Frage war nicht dabei?">
      <template slot="answer">
        <ul>
          <li>
            <a
              rel="noopener noreferrer"
              class="colorBlue"
              href="https://mobil.hessen.de/kontakt"
              target="_blank"
            >Schreiben Sie uns. Wir freuen uns über Ihre Hinweise.</a>
          </li>
        </ul>
      </template>
    </Accordeon>
  </div>
</template>

<script>
import Accordeon from "./../../CoreComponents/Accordeon.vue";
export default {
  name: "FAQAllgemeines",
  components: { Accordeon }
};
</script>

<style scoped>
</style>
